import { render, staticRenderFns } from "./yiYellow.vue?vue&type=template&id=26322d52&scoped=true&"
import script from "./yiYellow.vue?vue&type=script&lang=js&"
export * from "./yiYellow.vue?vue&type=script&lang=js&"
import style0 from "./yiYellow.vue?vue&type=style&index=0&id=26322d52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26322d52",
  null
  
)

export default component.exports